







import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  Claim
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import HsabInsuranceClaim from "@/employee/components/landing-pages/hsabank/expense/HsabInsuranceClaim.vue";
import { useClaimStore } from "@/employee/store/claim";

@Component({
  components: {
    HsabInsuranceClaim
  }
})
export default class HsabExpenseCardRowInsuranceClaim extends Vue {
  formatCurrency = formatCurrency;
  claimStore = useClaimStore();

  @Prop({required: true})
  expense: any;

  beforeMount () {
    this.claimStore.initializeLinkedClaimsState(this.expense.hsabExpenseId);
  }
  mounted () {
    this.claimStore.loadLinkedClaims(this.expense.hsabExpenseId);
  }
  get hasLinkedClaims (): boolean {
    return this.claimStore.linkedClaims(this.expense.hsabExpenseId)
      && this.claimStore.linkedClaims(this.expense.hsabExpenseId).length > 0;
  }
  get linkedClaim (): Claim {
    if (this.hasLinkedClaims) {
      return this.claimStore.linkedClaims(this.expense.hsabExpenseId)[0].claim;
    }
    return null;
  }
}
